import { differenceInHours } from "date-fns";

export const isMoreThan24HoursAgo = (date) => {
  return !(differenceInHours(date, new Date()) >= 24);
};
